import {firestore} from 'firebase'

export const USERS_COLLECTION_NAME = 'users'

export const userDocument = (userId: string) => {
	return firestore()
		.collection(USERS_COLLECTION_NAME)
		.doc(userId)
}
